export default class OccurrenceDetail
  handler_events: ->
    $('.problems_table').on 'click', ->
      problem = $(@)
      type = problem.data('type')
      problem_id = problem.data('problem-id')

      unless type == 0
        occurrence_id = problem.data('problem-id')
        Turbolinks.visit('/occurrences/' + occurrence_id + '/details')